import Swiper from 'swiper/bundle';

$(function () {
    let el = $('.article-swiper');
    if (el.length > 0) {
        new Swiper('.article-swiper', {
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            init: true,
            slidesPerView: 1,
            spaceBetween: 70,
            breakpoints: {
                992: {
                    slidesPerView: 2
                },
                1400: {
                    slidesPerView: 3
                }
            },
            watchOverflow: true
        });
    }
});